import React from "react";

import { formatPrice } from "@app/scripts/utils";

import type { Cart, FreeShipping } from "@app/scripts/types";

type Props = {
  cart: Cart | null;
  freeShipping?: FreeShipping;
  shippingHeading?: string;
  shippingHeadingUnder?: string;
};

export const CartFreeShipping: React.FC<Props> = ({ cart, freeShipping, shippingHeading, shippingHeadingUnder }) => {

  const localFreeShipping = cart?.currency ? freeShipping?.[cart.currency] ?? freeShipping?.["DEFAULT"] : freeShipping?.["DEFAULT"];

  const priceUntilFreeShipping =
    cart && localFreeShipping ? formatPrice(localFreeShipping - cart.items_subtotal_price / 100, cart.currency) : null;
  const hasFreeShipping = cart && localFreeShipping && localFreeShipping <= cart.items_subtotal_price / 100;
  const freeShippingBarWidth =
    cart && localFreeShipping ? Math.min((cart.items_subtotal_price / 100 / localFreeShipping) * 100, 100) : null;

  const strings = {
    shippingHeading: shippingHeading || "You’re receiving free standard shipping.",
    shippingHeadingUnder: priceUntilFreeShipping
      ? shippingHeadingUnder?.replace("{price}", priceUntilFreeShipping || "") ||
        `You’re <strong>${priceUntilFreeShipping} away</strong> from free standard shipping.`
      : "",
  };

  return localFreeShipping ? (
    <div className={`cart__free-shipping text-sm ${hasFreeShipping ? "active" : ""}`}>
      <div className="cart__free-shipping__message">
        {hasFreeShipping ? (
          <ui-icon width="12" height="12" name="icon-check-large"></ui-icon>
        ) : (
          <>
            <ui-icon width="16" height="16" name="icon-truck"></ui-icon>
          </>
        )}
        {hasFreeShipping ? (
          <span>{strings.shippingHeading}</span>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: strings.shippingHeadingUnder }} />
        )}
      </div>
      <div className="cart__free-shipping-bar">
        <span style={{ width: `${freeShippingBarWidth}%` }} />
      </div>
    </div>
  ) : null;
};
